// extracted by mini-css-extract-plugin
module.exports = {"root":"Imprint_root__D4K3P","lastUpdated":"Imprint_lastUpdated__1_lW2","listIndent":"Imprint_listIndent__3vgT8"};